var CaregiverInvitationErrorCode;
(function (CaregiverInvitationErrorCode) {
    CaregiverInvitationErrorCode[CaregiverInvitationErrorCode["RESEND_NOT_ALLOWED"] = 32] = "RESEND_NOT_ALLOWED";
    CaregiverInvitationErrorCode[CaregiverInvitationErrorCode["FORBIDDEN_ACCOUNT_ROLE_ERROR"] = 18] = "FORBIDDEN_ACCOUNT_ROLE_ERROR";
    CaregiverInvitationErrorCode[CaregiverInvitationErrorCode["CAREGIVER_IN_DIFFERENT_COUNTRY"] = 31] = "CAREGIVER_IN_DIFFERENT_COUNTRY";
    CaregiverInvitationErrorCode[CaregiverInvitationErrorCode["TOO_MANY_CAREGIVER_CONNECTIONS"] = 30] = "TOO_MANY_CAREGIVER_CONNECTIONS";
    CaregiverInvitationErrorCode[CaregiverInvitationErrorCode["RESOURCE_ALREADY_EXISTS_CODE"] = 2] = "RESOURCE_ALREADY_EXISTS_CODE";
    CaregiverInvitationErrorCode[CaregiverInvitationErrorCode["UNKNOWN"] = 0] = "UNKNOWN";
})(CaregiverInvitationErrorCode || (CaregiverInvitationErrorCode = {}));
export default CaregiverInvitationErrorCode;
